<script>
import { get } from 'lodash'
import { routeStartsWith } from '@/helpers/routes'
import APP_URL from '@/plugins/http/appURL'
import LOGIN_TO_PROFESSIONAL from '@/plugins/http/professional'
import REGISTER_TO_PROFESSIONAL from '@/plugins/http/professional-register'
import LOGIN_TO_PATIENT from '@/plugins/http/patient'
import REGISTER_TO_PATIENT from '@/plugins/http/patient-register'

export default {
  name: 'patient-mobile',
  data: () => {
    return {
      mobileMenuOn: false,
      APP_URL: APP_URL,
      LOGIN_TO_PROFESSIONAL: LOGIN_TO_PROFESSIONAL,
      REGISTER_TO_PROFESSIONAL: REGISTER_TO_PROFESSIONAL,
      LOGIN_TO_PATIENT: LOGIN_TO_PATIENT,
      REGISTER_TO_PATIENT: REGISTER_TO_PATIENT
    }
  },
  computed: {
    routeIsPatientLoadingPage () {
      if (get(this.$route, 'path', null) === '/') {
        this.pathIndex = true
        return this.$router.push({name: 'patient.loading-page.index'})
      }
      this.pathIndex = true
      return routeStartsWith(this.$route, 'patient.loading-page.')
    },
    routeIsProfessionalLoadingPage () {
      this.pathIndex = false
      return routeStartsWith(this.$route, 'professional.loading-page.')
    },
    isIndex () {
      if (get(this.$route, 'path', null) === '/') {
      }
    }
  },
  methods: {
    goToTerms () {
      location.href = this.APP_URL + '/app/terms/term'
    },
    goToPolicy () {
      location.href = this.APP_URL + '/app/terms/policy'
    },
    goToLoginPatient () {
      location.href = this.LOGIN_TO_PATIENT
    },
    goToRegisterPatient () {
      location.href = this.REGISTER_TO_PATIENT
    },
    goToLoginProfessional () {
      location.href = this.LOGIN_TO_PROFESSIONAL
    },
    goToRegisterProfessional () {
      location.href = this.REGISTER_TO_PROFESSIONAL
    }
  }
}
</script>

<template lang="pug">
    div
      #menu-mobile-icon.menu-mobile-off(:class="{'menu-mobile-on': mobileMenuOn}", @click.prevent='mobileMenuOn = !mobileMenuOn')
        .first-line
        .second-line
        .third-line

      #menu-mobile.menu-mobile-off(:class="{'menu-mobile-on': mobileMenuOn}")
        ul
          a(href='', v-scroll-to="'#apresentacao'", @click.prevent="mobileMenuOn = false")
            li.apresentacao Apresentação
          a(href='', v-scroll-to="'#beneficios'", @click.prevent="mobileMenuOn = false", v-if='routeIsPatientLoadingPage || !routeIsProfessionalLoadingPage')
            li.beneficios Benefícios
          a(href='', v-scroll-to="'#contato'", @click.prevent="mobileMenuOn = false")
            li.contato Contato
          .line
          a.mb-cursor-pointer(@click.prevent="goToTerms()", target="_blank")
            li Termos de Uso
          a.mb-cursor-pointer(@click.prevent="goToTerms()", target="_blank")
            li Políticas de Privacidade


      #login-mobile(v-if='routeIsPatientLoadingPage || !routeIsProfessionalLoadingPage')
        .container
          .col-xs-6
            a.button.mb-cursor-pointer(@click.prevent="goToLoginPatient()")
              | Entrar
              span.icon 

          .col-xs-6
            a.mb-cursor-pointer.button(@click.prevent="goToRegisterPatient()")
              | Cadastro
              span.icon 

      a#login-mobile(v-if='routeIsProfessionalLoadingPage')
        .container
          .col-xs-6
            a.mb-cursor-pointer.button(@click.prevent="goToLoginProfessional()")
              | Entrar
              span.icon 
          .col-xs-6
            a.mb-cursor-pointer.button(@click.prevent="goToRegisterProfessional()")
              | Cadastro
              span.icon 
</template>
<style scoped>
  .mb-cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/layout/headers/mobile/patient.vue